import React, { FC, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { Icon, Empty } from '@cps'
import { buyTogetherMobx, storeMobx, themeMobx, locationMobx } from '@mobxStore'
import { find, keyBy, sortBy } from '@dt/fe-utils/dist/lodash'
import StoreItem from '../StoreItem'
import StoreSearch from '../StoreSearch'
import './index.scss'

import noStoreCloseImg from '@img/no-store-close.png'

interface IProps {
  /** 是否开启lbs */
  isLBS?: boolean;
  targetType?: string;
  /** 选择门店 */
  onSelectStore?(store?: IViewStore): void;
  mapShow?(type: boolean): void;
  onSelectMap?(store?: IViewStore): void;
  isStoreMore?: boolean;
  setIsStoreMore?(type: boolean): void;
  searchTitle?: string;
}

const StoreList: FC<IProps> = ({ isLBS = false, targetType, onSelectStore, mapShow, setIsStoreMore, isStoreMore, searchTitle }) => {
  const { locationIsOpen } = locationMobx
  const maxHeight = document.body.offsetHeight - 360
  // 上拉事件
  const onChangeBox = () => {
    setIsStoreMore(!isStoreMore)
  }
  // 拼单门店筛选
  const getStoreList = useMemo(() => {
    switch (targetType) {
      case 'buyTogether':
        return storeMobx.viewStoreList.filter((store) => store.buyTogetherEatTypes.includes(buyTogetherMobx.eatType))
      default:
        return storeMobx.viewStoreList
    }
  }, [storeMobx.viewStoreList])

  const handleStoreClassify: {
    boughtStore?: IViewStore;
    nearStore?: IViewStore;
    moreList: IViewStore[];
  } = useMemo(() => {
    // 拼单外卖门店
    let storeList = getStoreList
    /** 月购数没有，或者门店数是1，就只展示全部门店，不去筛选最近和月购 */
    if (!storeMobx.storeBoughtList.length || storeList.length === 1) {
      return {
        moreList: storeList
      }
    }

    /** 距离排序 */
    storeList = sortBy(storeList, 'distance')

    /** 月购日期最近的门店 */
    const boughtItem = storeMobx.storeBoughtList[0] || null // 月购
    /** 月购门店 */
    let boughtStore = find(storeList, (item) => boughtItem?.storeId === String(item.storeId))
    /** 最近的门店 */
    let nearStore = isLBS ? storeList[0] : null
    /** 更多门店 */
    const moreList = []

    /** 月购和最近门店是同一家就隐藏 */
    if (boughtStore?.storeId === nearStore?.storeId) nearStore = null

    /** 需要把当前选中的放到更多列表第一个 */
    if (storeMobx.info.storeId) {
      storeList = sortBy(storeList, (store) => store.storeId === storeMobx.info.storeId ? 0 : 1)
    }
    storeList.forEach((item) => {
      if (targetType === 'buyTogether') {
        if (item.isOpenBuyTogether !== 1) return
        if (buyTogetherMobx.eatType === 'delivery' && item.openSelfDelivery !== 1) return
      }
      // 非月购和最近门店都放入更多门店列表
      if (nearStore?.storeId !== item.storeId && boughtStore?.storeId !== item.storeId) {
        moreList.push({
          ...item,
          boughtCnt: 0
        })
      }
    })
    return {
      boughtStore,
      nearStore,
      moreList
    }
  }, [storeMobx.viewStoreList, storeMobx.storeBoughtList])

  /** 显示地图 */
  const clearMore = (e) => {
    setIsStoreMore(false)
    const ev = e || window.event
    ev.stopPropagation()
  }
  useEffect(() => {
    if (!locationIsOpen) {
      setIsStoreMore(true)
    }
  }, [])

  return (
    <div className='store-list-box' style={{ transform: `translateY(${isStoreMore ? (0 - maxHeight) + 'px' : '-88px'})` }}>
      <StoreSearch clearMore={clearMore} mapShow={mapShow} searchTitle={searchTitle} />
      <p className='store-list-sort-top' onClick={() => { onChangeBox() }}>
        {isStoreMore ? <Icon name='chevron-down' /> : <Icon name='chevron-up' />}
      </p>
      <div className='store-list-content' style={{ height: `${isStoreMore ? (212 + maxHeight) + 'px' : '300px'}` }}>
        {
          handleStoreClassify.boughtStore || handleStoreClassify.moreList?.length ? (
            <>
              <div className='store-bought-wrapper'>
                <StoreItem store={handleStoreClassify.boughtStore} type='bought' onSelectStore={onSelectStore} />
                <StoreItem store={handleStoreClassify.nearStore} type='near' onSelectStore={onSelectStore} />
              </div>
              <div className='store-list-more'>
                <p className='store-list-title'>{i18n.t(handleStoreClassify.moreList?.length === getStoreList?.length ? 'store.allStore' : isLBS ? 'location.storeSort' : 'store.moreStore')}</p>
                {
                  handleStoreClassify.moreList?.map(store => <StoreItem key={store.storeId} store={store} onSelectStore={onSelectStore} />)
                }
              </div>
              <p className='no-more'>{i18n.t('common.noMore')}</p>
            </>
          ) : (
            <Empty
              msg={i18n.t('store.noStoreCity')}
              iconType='dicon'
              iconName={themeMobx?.data?.abnormalStateSetting[3]?.icon}
              picUrl={themeMobx?.data?.abnormalStateSetting[3]?.pic || noStoreCloseImg}
              height='40vh'
            />
          )
        }
      </div>
    </div>
  )
}
export default observer(StoreList)
